exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".slider{display:block;position:relative;height:36px;width:100%;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;-o-user-select:none;user-select:none}.slider .slider-touch-left,.slider .slider-touch-right{box-sizing:border-box;display:block;position:absolute;height:36px;width:36px;padding:6px;z-index:2}.slider .slider-touch-left span,.slider .slider-touch-right span{display:block;width:100%;height:100%;background:#f0f0f0;border:1px solid #a4a4a4;border-radius:50%}.slider .slider-line{box-sizing:border-box;position:absolute;width:calc(100% - 36px);left:18px;top:16px;height:4px;border-radius:4px;background:#f0f0f0;z-index:0;overflow:hidden}.slider .slider-line span{display:block;height:100%;width:0;background:#163247}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-45feea79","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/make-your-bookings/DoubleRangeSlider.vue
// module id = 877
// module chunks = 0